import { Component, EventEmitter, Input, Output, forwardRef } from '@angular/core';
import { NgClass, NgTemplateOutlet } from '@angular/common';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

import { IconComponent } from '@atoms/icon/icon.component';
import { InputErrorComponent } from '@atoms/input-error/input-error.component';

@Component({
  selector: 'app-checkbox',
  imports: [NgClass, NgTemplateOutlet, IconComponent, InputErrorComponent],
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => CheckboxComponent),
    },
  ],
})
export class CheckboxComponent implements ControlValueAccessor {
  @Input() name: string = '';
  @Input() value?: string | number;
  @Input() href?: string;
  @Input() disabled: boolean = false;
  @Input() required: boolean = false;
  @Input() error: boolean = false;
  @Input('font-size') fontSize: 'default' | 'small' | 'large' = 'default';
  @Input('error-message') errorMessage?: string;
  @Input() active?: boolean;
  @Input() type: 'checkbox' | 'radio' = 'checkbox';
  @Output() activeChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  public onChange = (value: boolean) => {};
  public onTouched = (value: boolean) => {};

  linkClick(e: Event): void {
    e.preventDefault();
    if (this.disabled) return;
    this.active = !this.active;
    this.activeChange.emit(this.active);
    this.onTouched(true);
    if (this.value) this.onChange(this.active);
  }

  change(): void {
    if (this.disabled) return;
    this.active = !this.active;
    this.onChange(this.active);
    this.activeChange.emit(this.active);
  }

  focus(): void {
    this.onTouched(true);
  }

  writeValue(obj: boolean): void {
    this.active = obj;
  }

  registerOnChange(fn: (value: boolean) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: (value: boolean) => void): void {
    this.onTouched = fn;
  }
}
